import { CellProps, Badge, Table } from "rsuite";
const { Cell } = Table;

export const BadgeCell = ({ rowData, dataKey, ...props }: CellProps) => {
  if (dataKey === "IsActive") {
    return (
      <Cell {...props}>
        <Badge
          className={rowData.IsActive ? "active-badge" : "inactive-badge"}
          content={
            <div className="d-flex flex-row align-items-center">
              <Badge className={rowData.IsActive ? "badge-dot-active" : "badge-dot-inactive"} />
              {rowData.IsActive ? <p>Active</p> : <p>InActive</p>}
            </div>
          }
        ></Badge>
      </Cell>
    )
  } else {
    return (
      <Cell {...props}>
        <Badge
          className={rowData.IsPaid ? "active-badge" : "inactive-badge"}
          content={
            <div className="d-flex flex-row align-items-center justify-content-center">
              {rowData.IsPaid ? <p>Paid</p> : <p>Trial</p>}
            </div>
          }
        />
      </Cell>
    )
  }
};
